import { useParams, Navigate } from "react-router-dom";
import { getHighlight, HIGHLIGHTS } from "@/data/highlights";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { SectionRenderer } from "@/components/blocks/SectionRenderer";
import { ImageGallery } from "@/components/blocks/ImageGallery";
import { RelatedTickets } from "@/components/cards/RelatedTickets";
import { RelatedLinks } from "@/components/cards/RelatedLinks";
import { CTASection } from "@/components/common/CTASection";

export default function HighlightDetail() {
  const { slug } = useParams();
  const page = getHighlight(slug);
  if (!page) return <Navigate to="/highlights" replace />;

  const relatedHighlightLinks = (page.relatedHighlights || [])
    .map((s) => HIGHLIGHTS.find((h) => h.slug === s))
    .filter(Boolean)
    .map((h) => ({ label: h.title, to: `/highlights/${h.slug}` }));

  return (
    <>
      <PageHero
        overline="Highlight"
        title={page.title}
        subtitle={page.subtitle}
        image={page.heroImage}
        breadcrumbs={[{ label: "Highlights", to: "/highlights" }, { label: page.title }]}
      />

      <div className="container-wide py-14 md:py-20">
        <Reveal>
          <p className="mx-auto max-w-3xl text-center font-serif text-2xl md:text-3xl font-light leading-relaxed text-charcoal text-balance">
            {page.intro}
          </p>
        </Reveal>

        {page.gallery && (
          <Reveal className="mt-12">
            <ImageGallery images={page.gallery} alt={page.title} />
          </Reveal>
        )}

        <div className="mx-auto mt-16 max-w-4xl md:mt-20">
          <SectionRenderer blocks={page.blocks} />
        </div>

        {(relatedHighlightLinks.length > 0 || page.relatedPlanning?.length) && (
          <div className="mx-auto mt-16 grid max-w-4xl gap-8 sm:grid-cols-2">
            {relatedHighlightLinks.length > 0 && (
              <RelatedLinks title="More highlights" links={relatedHighlightLinks} testId="highlight-related-highlights" />
            )}
            {page.relatedPlanning?.length > 0 && (
              <RelatedLinks title="Plan your visit" links={page.relatedPlanning} testId="highlight-related-planning" />
            )}
          </div>
        )}
      </div>

      <RelatedTickets
        slugs={page.relatedTickets}
        overline="Experience it yourself"
        title="Tickets that include this"
        description="Choose a ticket or tour that brings you closest to this part of the Colosseum."
      />

      <div className="container-wide pb-20">
        <CTASection image={page.heroImage} />
      </div>
    </>
  );
}
